import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Rekbot } from '../../models/rekbot.model';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { User } from '../../models/user.model';
import { UsersService } from '../../services/users.service';
import { AuthService } from '../../services/auth.service';
import { PermissionsService } from '../../services/permissions.service';

@Component({
    selector: 'app-user',
    imports: [
        MatTableModule,
        MatPaginatorModule,
        MatIconModule,
        MatFormFieldModule
    ],
    templateUrl: './user.component.html',
    styleUrl: './user.component.css'
})
export class UserComponent implements OnInit, AfterViewInit {

  private elementId: number = 0;

  public userData: User = {
    id: 0,
    email: "",
    name: "",
    surname: "",
    phone: "",
    is_admin: 0,
    recbot_api_token: "",
    namedType: ""
  };

  public rekbotStatuses = [
    {
      value: 0,
      name:'ERROR'
    },
    {
      value: 1,
      name: 'OK'
  }];

  public displayedColumns: string[] = [
    'serial_no', 
    'ipv4', 
    'status', 
    /*'restart_application', 
    'restart_api', 
    'restart_plc', 
    'restart_pc', 
    'action'*/
  ];

  public rekbots: Rekbot[] = [];

  public dataSource = new MatTableDataSource<any>(this.rekbots);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  @ViewChild('content') content: any;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    public usersService: UsersService,
    public authService: AuthService,
    public permissionsService: PermissionsService
  ) {

  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

  }

  ngOnInit(): void {

    this.permissionsService.verifyAccess();

    /*if(this.authService.user?.is_admin === undefined || this.authService.user?.is_admin === 0) {
      this.router.navigate(['rekbots-list']);
    }*/

    this.elementId = this.route.snapshot.params['rekbotId'];

    if(this.elementId > 0) {
      this.fetchUser(this.elementId)
    }
    console.log("ngOnInit dataSource", this.dataSource)
    //this.fetchUser()
  }

  fetchUser(id: number) {
    this.usersService.getUser(id)
  }

  deleteElement(element: Rekbot) {
  }

  doFilter(event: Event) {
    //let value = filterValue.target.value
    const filterValue = (event.target as HTMLInputElement).value;

    console.log("do filter arg", filterValue)
    this.dataSource.filter = filterValue.trim().toLowerCase()
  }  

}
